import React from 'react';
import './App.css';
import Games from './components/Games/Games';


const App = () => {
  return (
    <div>
      <Games />
    </div>
  );
}

export default App;
